import React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const BankIcon = ({ size = 28, color = '#596379', ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_6479_31546)">
        <Path
          d="M23.5569 22.6357H3.95855C3.25679 22.6357 2.68262 23.2099 2.68262 23.9117C2.68262 24.6134 3.25679 25.1876 3.95855 25.1876H23.5442C24.2459 25.1876 24.8201 24.6134 24.8201 23.9117C24.8201 23.2099 24.2459 22.6357 23.5442 22.6357H23.5569Z"
          fill={color}
        />
        <Path
          d="M4.17535 11.6627H6.7017V18.9738H5.29818C4.59641 18.9738 4.02224 19.548 4.02224 20.2498C4.02224 20.9515 4.59641 21.5257 5.29818 21.5257H22.7019C23.4037 21.5257 23.9779 20.9515 23.9779 20.2498C23.9779 19.548 23.4037 18.9738 22.7019 18.9738H21.4515V12.071C21.4515 11.9307 21.4133 11.7903 21.375 11.6627H23.6717C24.9986 11.6627 25.5473 10.1699 24.4883 9.4681L20.8901 7.12038L14.7401 3.10118C14.2552 2.78219 13.6045 2.78219 13.1197 3.10118L6.96965 7.12038L3.37151 9.4681C2.31248 10.1571 2.86114 11.6627 4.18811 11.6627H4.17535ZM18.989 11.6627C18.9507 11.7903 18.9124 11.9179 18.9124 12.071V18.9738H15.2888V11.6627H19.0017H18.989ZM12.7241 11.6627V18.9738H9.25358V11.6627H12.7241Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_6479_31546">
          <Rect width={`${size}`} height={`${size}`} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default BankIcon
